import { createContext, useCallback, useContext } from 'react';
import type { AnalyticsItem, AnalyticsItemClickHandler } from './interfaces';

export const AnalyticsItemClickContext =
  createContext<AnalyticsItemClickHandler | null>(null);

export const AnalyticsItemPositionContext = createContext<number | undefined>(
  undefined
);

export const useTrackItemClick = (item?: AnalyticsItem) => {
  const onItemClick = useContext(AnalyticsItemClickContext);
  const position = useContext(AnalyticsItemPositionContext);
  const type = item?.type;
  const id = item?.id;

  return useCallback(() => {
    if (!onItemClick || !type || !id) return;

    onItemClick({ type, id, position });
  }, [onItemClick, type, id, position]);
};
